import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from '../actions/nfc.actions';
import { NFCModel } from '../../models/nfc.model';
export const featureKey = 'nfc';

export interface NFCState {
  data: NFCModel[] | any;
  loaded: {
    success: boolean | any,
    after: string | any,
    data?: any
  }
  hasError: boolean;
  loading: boolean;
  error: any;
  success: any
};

export const initialState: NFCState = {
  data: null,
  loaded: {
    success: false,
    after: '',
    data: ''
  },
  hasError: false,
  loading: false,
  error: null,
  success: false
};

const nfcReducer = createReducer(initialState,

  on(fromActions.loadNFCDevicesBegin, state => ({ ...state, loading: true })),

  on(fromActions.loadNFCDevicesSuccess, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: {
      success: true,
      after: 'NFC_DEVICES_LOADED'
    },
    hasError: false,
    data: payload,
    success: true
  })),

  on(fromActions.loadNFCDevicesError, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: {
      success: false,
      after: 'NFC_DEVICES_LOADED'
    },
    hasError: true,
    error: payload,
    success: false
  })),

  on(fromActions.createNFCDeviceBegin, state => ({ ...state, loading: true })),

  on(fromActions.createNFCDeviceSuccess, (state, { card }) => Object.assign({}, state, {
    data: [...state.data, card],
    loading: false,
    success: {
      after: 'NFC_ACTIVATED',
      message: ''
    }
  })),

  on(fromActions.createNFCDeviceError, (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload
  })),


  on(fromActions.clearNFCDevicesSuccessErrorData, (state) => ({
    ...state,
    loaded: {
      success: null,
      after: '',
      data: ''
    },
    success: {
      after: ''
    }
  })),

  on(fromActions.updateNFCDeviceBegin, state => ({ ...state, loading: true })),

  on(fromActions.updateNFCDeviceSuccess, (state, { card }) => {
    return {
      ...state,
      data: state.data.map((item: any) =>
        item.id === card.id ? { ...item, ...card } : item
      ),
      loading: false,
      success: {
        after: 'NFC_UPDATED',
        message: ''
      }
    };
  }),

  on(fromActions.updateNFCDeviceError, (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload
  })),

);

export const NFCReducer = (state: NFCState | undefined, action: Action) =>
  nfcReducer(state, action);

export const isLoading = (state: NFCState) => state.loading;
export const succeeded = (state: NFCState) => state.loaded;
export const hasError = (state: NFCState) => state.hasError;
export const errorMessage = (state: NFCState) => state.error;
export const nfcDevices = (state: NFCState) => state.data;
